import { Box, Typography } from '@mui/material'
import { formatPrice } from '@popety_io/popety-io-lib'

interface PriceDisplayProps {
  value?: number
  fontSize?: string
  fontSizeM2?: string
  perM2Value?: number
  showPerM2?: boolean
}

export const PriceDisplay = ({
  value,
  fontSize = '1rem',
  fontSizeM2 = '0.8rem',
  perM2Value,
  showPerM2 = true,
}: PriceDisplayProps) => {
  return (
    <>
      <Box>
        {value ? (
          <Box
            sx={{
              opacity: 0.7,
              userSelect: 'none',
              fontSize,
              color: 'primary.main',
              fontWeight: 600,
            }}
          >
            {formatPrice(Number(value)) || '-'}
          </Box>
        ) : (
          <Box
            sx={{
              opacity: 0.7,
              userSelect: 'none',
              fontSize,
              color: 'primary.main',
              fontWeight: 600,
            }}
          >
            CHF -
          </Box>
        )}
      </Box>
      {showPerM2 ? (
        <Typography
          sx={{
            color: '#969696',
            paddingBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
          fontSize={fontSizeM2}
        >
          {value ? (
            <Box>{formatPrice(perM2Value || 0)} /m2</Box>
          ) : (
            <Box
              sx={{
                opacity: 0.7,
                userSelect: 'none',
              }}
            >
              CHF - /m2
            </Box>
          )}
        </Typography>
      ) : (
        <Box sx={{ padding: '15px' }} />
      )}
    </>
  )
}
